<div class="flex align-items-center justify-content-between pb-2 border border-bottom-1 p-2 bg-white sticky top-0 z-1
custom-dialog">
  <h4>Select User Role</h4>
  @if (isShowCloseButton) {
    <p-button icon="pi pi-times" [rounded]="true" text (onClick)="closeDialog()"></p-button>
  }
</div>

<div class="row">
  <div class="col-12 text-center">
    <span>Please select a user role to view the respective application screen.</span>
  </div>
  <div class="flex justify-content-center">
    <div class="flex flex-column">
      <label for="username" class="form-label">Select Role</label>
      <p-select [options]="userRolesList" optionLabel="user_role"  [checkmark]="false"
        [showClear]="false" placeholder="Select Role" [(ngModel)]="selectedUserRole" appendTo="body"
        [styleClass]="'titleDropdown dropdown-group'" />
    </div>
  </div>
  <div class="col-12">
    <div class="submit-btn text-end mt-3 mb-2">
      <div class="flex justify-content-center mt-3">
        <div class="flex justify-content-center gap-2">
          <p-button label="OK" type="submit" [disabled]="!isEnableSubmitButton()" [inert]="!isEnableSubmitButton()" (onClick)="onUserRoleChange()" />
        </div>
      </div>
    </div>
  </div>
</div>
